module.exports = __webpack_public_path__ + "static/media/sr.ceae0ffa.svg";